import { clamp } from '../../render/utils/math';

export const gaussianBlur = {
  name: 'gaussian blur',
  shader: `precision mediump float;
varying vec2 v_texCoord;
uniform sampler2D u_image;
uniform vec2 u_resolution;
uniform vec2 u_direction;

void main() {
    vec3 final_color = vec3(0.0);
    vec2 pixel_size = 1.0 / u_resolution;

    float weights[5];
    weights[0] = 0.227027; // Center
    weights[1] = 0.194595; // +/- 1
    weights[2] = 0.121622; // +/- 2
    weights[3] = 0.054054; // +/- 3
    weights[4] = 0.016216; // +/- 4

    final_color += texture2D(u_image, v_texCoord).rgb * weights[0];

    for (int i = 1; i <= 4; i++) {
        vec2 offset_uv = u_direction * pixel_size * float(i);
        final_color += texture2D(u_image, clamp(v_texCoord + offset_uv, 0.0, 1.0)).rgb * weights[i];
        final_color += texture2D(u_image, clamp(v_texCoord - offset_uv, 0.0, 1.0)).rgb * weights[i];
    }

    gl_FragColor = vec4(final_color, texture2D(u_image, v_texCoord).a);
}`,
  uniforms: [
    {
      name: 'radius',
      default: 1,
      normalize: (val) => clamp((val / 100) * 50, 0, 50),
    },
  ],
  pass(params: { radius: number }) {
    const radius = params.radius;
    if (radius < 0.1) {
      return [];
    }

    const sigmaIdeal = radius / 3;
    const sigmaPerPass = 1.5;
    const passes = (sigmaIdeal * sigmaIdeal) / (sigmaPerPass * sigmaPerPass);
    const passCount = Math.max(1, Math.ceil(passes));

    let direction = [1.0, 0.0];
    return Array.from({ length: passCount * 2 }).map(() => {
      const result = {
        u_direction: direction,
        u_sigma: sigmaPerPass,
      };
      direction = direction[0] === 1.0 ? [0.0, 1.0] : [1.0, 0.0];
      return result;
    });
  },
};
